// extracted by mini-css-extract-plugin
module.exports = {"donationSummaryList":"DonationSummary_donationSummaryList___S4Lw"};